import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import ComputeLocalMinMax from '../stages/preprocess/ComputeMinMaxStage';
import SortStage from '../stages/preprocess/SortStage';

export type MapParams = BlockParameters;

@AddMetadata({
    type: BlockKeys.Map,
    name: 'Map',
    description: 'Remaps the rainbow color gradient to the min-max values of the currently active Sensor Points',
})
class MapBlock extends PipelineBlock<MapParams> {
    constructor(params: MapParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [new SortStage(), new ComputeLocalMinMax()];
    }
}

export default MapBlock;
